module.exports = __webpack_public_path__ + "static/media/Lato-Bold.5dfc529d.woff";